/**
 * nc-autocomplete-build — construit les <li> de l'autocomplete produit à partir
 * du blob JSON produits, au lieu du rendu serveur (~149 <li> = ~118 Ko).
 *
 * Données : récupérées dans l'ordre
 *   1. inline #{ul.dataset.products} (<script application/json>) — rétrocompat ;
 *   2. cache mémoire/sessionStorage (déjà fetché cette session) ;
 *   3. fetch différé de `ul.dataset.productsSrc` (= /?view=ac-data) — sort le
 *      payload du HTML critique (home, PDP, devis). Préchargé en idle ; à défaut,
 *      au 1er appel. Quand le fetch aboutit après coup, un événement
 *      `nc:autocomplete-built` est émis sur le <ul> pour recapture côté composant.
 *
 * window.ncBuildAutocompleteList(ul) :
 *   - construit les <li> (populaires d'abord, badge ; puis le reste ; puis l'option
 *     custom si data-custom-label), en respectant EXACTEMENT le contrat DOM attendu
 *     (role=option, aria-selected, data-value, .nc-autocomplete__*),
 *   - idempotent (ne reconstruit jamais 2×).
 *   Retourne true si une construction synchrone a eu lieu, false sinon (données
 *   pas encore prêtes → construction asynchrone + événement).
 */
(function () {
  if (window.ncBuildAutocompleteList) return;

  var SS_KEY = 'nc-ac-data';
  var _cache = null;     // tableau parsé une fois résolu
  var _promise = null;   // fetch en vol (dédup)

  function el(tag, cls) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    return node;
  }

  function buildLi(id, name, type, img, popular, badge, iconNode) {
    var li = el('li');
    li.id = id;
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');
    li.setAttribute('data-value', name);
    if (popular) li.setAttribute('data-popular', '1');

    var row = el('div', 'nc-autocomplete__row');
    var thumb = el('div', 'nc-autocomplete__thumb');
    if (img) {
      var im = el('img');
      im.src = img;
      im.alt = name;
      im.width = 52;
      im.height = 52;
      im.loading = 'lazy';
      thumb.appendChild(im);
    } else if (iconNode) {
      thumb.appendChild(iconNode.cloneNode(true));
    }

    var info = el('div', 'nc-autocomplete__info');
    var nameEl = el('span', 'nc-autocomplete__name');
    nameEl.textContent = name;
    info.appendChild(nameEl);
    if (type) {
      var typeEl = el('span', 'nc-autocomplete__type');
      typeEl.textContent = type;
      info.appendChild(typeEl);
    }

    row.append(thumb, info);
    if (popular && badge) {
      var badgeEl = el('span', 'nc-autocomplete__badge');
      badgeEl.textContent = badge;
      row.appendChild(badgeEl);
    }
    li.appendChild(row);
    return li;
  }

  // ── Résolution des données ────────────────────────────────────────────
  function readInline(id) {
    var dataEl = id && document.getElementById(id);
    if (!dataEl) return null;
    try {
      var d = JSON.parse(dataEl.textContent);
      return Array.isArray(d) ? d : null;
    } catch (e) {
      return null;
    }
  }

  // Préserve le contexte d'aperçu : sur un thème non publié (éditeur de thème,
  // design mode, ?preview_theme_id=…), un fetch relatif taperait le thème LIVE et
  // récupérerait le mauvais endpoint. On propage donc preview_theme_id si présent.
  function resolveSrc(src) {
    try {
      var pid = new URLSearchParams(location.search).get('preview_theme_id');
      if (pid) src += (src.indexOf('?') >= 0 ? '&' : '?') + 'preview_theme_id=' + encodeURIComponent(pid);
    } catch (e) { /* URL API indispo — fetch nu */ }
    return src;
  }

  function fetchData(src) {
    if (_cache) return Promise.resolve(_cache);
    if (_promise) return _promise;
    try {
      var ss = sessionStorage.getItem(SS_KEY);
      if (ss) {
        var cached = JSON.parse(ss);
        if (Array.isArray(cached)) { _cache = cached; return Promise.resolve(_cache); }
      }
    } catch (e) { /* sessionStorage indisponible — on fetch */ }

    _promise = fetch(resolveSrc(src), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var text = t.trim();
        var d = JSON.parse(text);
        if (!Array.isArray(d)) throw new Error('payload inattendu');
        _cache = d;
        try { sessionStorage.setItem(SS_KEY, text); } catch (e) { /* quota/privé */ }
        return d;
      })
      .catch(function () { _promise = null; return null; });
    return _promise;
  }

  // ── Construction ──────────────────────────────────────────────────────
  function buildInto(ul, data) {
    if (!ul || ul.dataset.ncBuilt) return false;
    if (!Array.isArray(data)) return false;

    var iconsTpl = document.getElementById(ul.dataset.products + '-icons');
    var pick = function (sel) {
      var span = iconsTpl && iconsTpl.content.querySelector(sel);
      return span ? span.firstElementChild : null;
    };
    var thumbIcon = pick('[data-icon="thumb"]');
    var customIcon = pick('[data-icon="custom"]');
    var badge = ul.dataset.popularBadge || '';

    var frag = document.createDocumentFragment();
    data.forEach(function (it, i) {
      frag.appendChild(
        buildLi(ul.id + '-opt-' + i, it.t, it.ty, it.img, it.p === 1, badge, thumbIcon)
      );
    });

    if (ul.dataset.customLabel) {
      frag.appendChild(
        buildLi(ul.id + '-opt-custom', ul.dataset.customLabel, ul.dataset.customDesc || '', null, false, '', customIcon)
      );
    }

    ul.appendChild(frag);
    ul.dataset.ncBuilt = '1';
    return true;
  }

  window.ncBuildAutocompleteList = function (ul) {
    if (!ul || ul.dataset.ncBuilt) return false;

    // 1. Données inline (rétrocompat) ou déjà en cache → construction synchrone.
    var data = readInline(ul.dataset.products) || _cache;
    if (data) return buildInto(ul, data);

    // 2. Sinon, fetch différé puis construction asynchrone + événement.
    var src = ul.dataset.productsSrc;
    if (!src) return false;
    fetchData(src).then(function (d) {
      if (d && buildInto(ul, d)) {
        ul.dispatchEvent(new CustomEvent('nc:autocomplete-built'));
      }
    });
    return false;
  };

  // ── Préchauffage idle du cache (1ʳᵉ ouverture sans délai perceptible) ──
  function preload() {
    var ul = document.querySelector('.nc-autocomplete__list[data-products-src]');
    if (ul && !readInline(ul.dataset.products)) fetchData(ul.dataset.productsSrc);
  }
  if ('requestIdleCallback' in window) {
    requestIdleCallback(preload, { timeout: 3000 });
  } else {
    setTimeout(preload, 1500);
  }
})();